import { render, staticRenderFns } from "./TableSelectionTotalCollapseItem.vue?vue&type=template&id=44e23730&scoped=true"
import script from "./TableSelectionTotalCollapseItem.vue?vue&type=script&lang=js"
export * from "./TableSelectionTotalCollapseItem.vue?vue&type=script&lang=js"
import style0 from "./TableSelectionTotalCollapseItem.vue?vue&type=style&index=0&id=44e23730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e23730",
  null
  
)

export default component.exports